@if (invoice(); as invoice) {
  <div class="relative flex flex-col overflow-y-auto md:overflow-hidden" [@rise]>
    <button type="button"
            class="md:hidden absolute top-[14px] right-[14px] z-10 size-8 rounded-full bg-white/[0.16] border-none text-white text-[14px] font-semibold cursor-pointer flex items-center justify-center hover:bg-white/[0.26]"
            (click)="matDialogRef.close()" aria-label="Close"><span>✕</span></button>

    <aside class="shrink-0 w-full md:w-[320px] h-auto md:h-full bg-[#0f3d3b] px-6 py-7 md:pt-8 md:pb-7 md:px-7 flex flex-col gap-4 items-center md:items-start text-center md:text-left">
      <div class="flex justify-center w-full" [@sparklePop]>
        <div class="size-[72px] rounded-full bg-[#66e5b2]/[0.18] flex items-center justify-center">
          <div class="size-14 rounded-full bg-[#66e5b2] shadow-[0_6px_14px_0_rgba(102,229,178,0.5)] flex items-center justify-center text-[28px] leading-none">✨</div>
        </div>
      </div>

      <h2 class="!m-0 w-full text-white !text-[22px] font-bold leading-[1.15]">Welcome back to {{ invoice.userPlan?.name }}!</h2>
      <p class="!m-0 w-full text-[#a1c4c7] text-[12px] leading-[1.5]">Your locked rates, balance and compliance support are restored. Picking up right where you left off.</p>

      <div class="bg-white/[0.06] border border-white/[0.12] rounded-[10px] px-[14px] py-3 flex flex-col gap-[6px] w-full text-left md:mb-auto">
        <span class="self-start inline-flex items-center gap-[6px] bg-[#66e5b2] text-[#022d35] text-[9px] font-bold tracking-[0.36px] py-[3px] pl-2 pr-[10px] rounded-[100px]">
          <span class="size-[6px] rounded-full bg-[#022d35]"></span>
          <span>{{ invoice.userPlan?.userPlanType }} · REACTIVATED</span>
        </span>
        <p class="!m-0 text-white text-[14px] font-semibold">
          @switch (invoice.userPlan?.billingCycle) {
            @case ('MONTHLY') {
              Monthly
            }
            @case ('YEARLY') {
              Annual
            }
          }
          subscription
        </p>
        <p class="!m-0 text-[#a1c4c7] text-[11px]">Active until {{ invoice.userPlan?.expirationDate | date:'d MMM yyyy' }}</p>
      </div>
    </aside>

    <section class="flex-1 h-auto md:h-full bg-white px-6 py-5 md:py-6 md:px-7 flex flex-col gap-[14px] min-w-0">
      <header class="flex items-center justify-between">
        <div class="flex flex-col gap-[2px]">
          <p class="!m-0 text-[#022d35] text-[16px] font-semibold">Everything restored</p>
          <p class="!m-0 text-[#6b7d82] text-[11px]">New invoice {{ invoice.uuid }}</p>
        </div>
        <button type="button"
                class="hidden md:flex size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer items-center justify-center text-[#6b7d82] text-[16px] font-bold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35]"
                (click)="matDialogRef.close()" aria-label="Close">×</button>
      </header>

      <div class="h-px w-full bg-[#dee3e3]"></div>

      <ul class="list-none !m-0 p-0 flex flex-col gap-[10px]">
        <li class="flex items-start gap-[10px]">
          <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white text-[11px] font-bold flex items-center justify-center">
            <mat-icon svgIcon="restore-icon" class="!w-ful !h-auto max-w-[8px] max-h-[10px]"></mat-icon>
          </span>
          <div class="flex-1 flex flex-col gap-[1px] min-w-0">
            <p class="!m-0 text-[#022d35] text-[13px] font-semibold">{{invoice.amount | number : '1.0-0'}} fresh balance</p>
            <p class="!m-0 text-[#6b7d82] text-[11px]">Across all 4 AML providers</p>
          </div>
        </li>
        <li class="flex items-start gap-[10px]">
          <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white text-[11px] font-bold flex items-center justify-center">
            <mat-icon svgIcon="restore-icon" class="!w-ful !h-auto max-w-[8px] max-h-[10px]"></mat-icon>
          </span>
          <div class="flex-1 flex flex-col gap-[1px] min-w-0">
            <p class="!m-0 text-[#022d35] text-[13px] font-semibold">Same locked rates</p>
            <p class="!m-0 text-[#6b7d82] text-[11px]">{{priceRange()}} USDT</p>
          </div>
        </li>
        <li class="flex items-start gap-[10px]">
          <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white text-[11px] font-bold flex items-center justify-center">
            <mat-icon svgIcon="restore-icon" class="!w-ful !h-auto max-w-[8px] max-h-[10px]"></mat-icon>
          </span>
          <div class="flex-1 flex flex-col gap-[1px] min-w-0">
            <p class="!m-0 text-[#022d35] text-[13px] font-semibold">{{ invoice.userPlan?.complianceHoursGranted }}h compliance reset</p>
            <p class="!m-0 text-[#6b7d82] text-[11px]">Counter starts over</p>
          </div>
        </li>
        <li class="flex items-start gap-[10px]">
          <span class="shrink-0 size-5 rounded-full bg-[#218c59] text-white text-[11px] font-bold flex items-center justify-center">
            <mat-icon svgIcon="restore-icon" class="!w-ful !h-auto max-w-[8px] max-h-[10px]"></mat-icon>
          </span>
          <div class="flex-1 flex flex-col gap-[1px] min-w-0">
            <p class="!m-0 text-[#022d35] text-[13px] font-semibold">Account manager re-assigned</p>
            <p class="!m-0 text-[#6b7d82] text-[11px]">Priority hack/theft support back online</p>
          </div>
        </li>
      </ul>

      <!-- <div class="hidden md:block flex-1 min-h-0"></div> -->

      <div class="flex flex-col-reverse md:flex-row gap-2 w-full mt-auto">
        <!-- <button type="button"
                class="flex-1 flex items-center justify-center gap-[6px] py-3 px-[14px] rounded-[10px] text-[13px] font-semibold cursor-pointer border border-[#dee3e3] bg-white text-[#022d35] transition-all hover:bg-[#f5f7f7] hover:border-[#022d35] active:scale-[0.98] w-full md:w-auto"
                (click)="downloadInvoice()">
          <span>↓</span><span>Download invoice</span>
        </button> -->
        <button type="button"
                class="group flex-1 flex items-center justify-center gap-[6px] py-3 px-[14px] rounded-[10px] text-[13px] font-semibold cursor-pointer border-none bg-[#022d35] text-white transition-all hover:bg-[#1a8c99] hover:shadow-[0_6px_16px_0_rgba(23,115,125,0.45)] active:scale-[0.98] w-full md:w-auto"
                (click)="goToDashboard()">
          Go to dashboard
          <span class="transition-transform group-hover:translate-x-[3px]">→</span>
        </button>
      </div>
    </section>
  </div>

}
